export type CustomerRatingsParams = { akl: string; slug: string; ftag?: string[] };

export const enum CustomerRatingsAndReviewsPageSearchParams {
  VARIATION_ID = 'sku',
  PAGE = 'page',
  SORTING = 'sort',
  FILTER_BY_RATING = 'rating',
}
